<template>
    <div class="prelative">
        <header class="flex-level pabsolute top--0 baseline">
            <h2 class="m-0" v-if="groupData.label && groupData.label !== ''">
                <slot name="header">{{ groupData.label }}</slot>
            </h2>

            <div class="ml-4">
                <tabs-nav :tabs="listings" :activeTab="activeListing" @tab-clicked="handleSelect" />
            </div>
        </header>

        <div class="flex-column hp-10">
            <router-view :key="$route.path" v-if="!loading"></router-view>
        </div>
    </div>
</template>

<script>
import TabsNav from 'vcomponents/utilities/TabsNav.vue';
import ListingConfig from './config';

const ConfigListings = new ListingConfig();

export default {
    props: {
        group: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            activeListing: '',
            loading: false,
            listings: [],
        };
    },
    created() {
        this.activeListing = this.$route.name;
        this.handleSelect(this.activeListing);
    },
    mounted() {
        this.feedListings();
    },
    computed: {
        groupData() {
            return ConfigListings.getGroup(this.group);
        },
    },
    methods: {
        handleSelect(key) {
            let listingData = this.groupData.listings.find((listing) => listing.id === key);
            if (listingData.route != this.$router.currentRoute.name) {
                this.activeListing = key;
                // you can pass special props to your component with params in second paramter of the route
                // this.$router.push({ name: listingData.route, params: {prefilter: {staff : 2}}})
                this.$router.push({ name: listingData.route });
            }
        },
        feedListings() {
            if (this.groupData.listings && this.groupData.listings.length > 0) {
                if (this.groupData.permissionRoute && this.groupData.permissionRoute != '') {
                    this.listings = ConfigListings.checkPermissionsListingGroup(
                        this.groupData.permissionRoute,
                        this.groupData.listings,
                    );
                } else {
                    this.listings = this.groupData.listings;
                }
            }
        },
        sameGroupRoute(route) {
            return !!this.listings.filter((listing) => listing.route === route).length;
        },
    },
    components: {
        TabsNav,
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (newRoute.path !== oldRoute.path) {
                this.activeListing = this.$route.name;
            }
            if (!this.sameGroupRoute(newRoute.name)) {
                this.feedListings();
            }
        },
    },
};
</script>
